import { regexes } from "@swa-ui/form";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const RAPID_REWARDS_NUMBER_SCHEMA_FIELD_NAME = "rapidRewardsNumber";

export const getRapidRewardsNumberFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .max(14)
    .matches(regexes.numeric, i18n("RapidRewardsNumberFormField__NUMERIC_ERROR"))
    .label(i18n("RapidRewardsNumberFormField__LABEL").toLowerCase());
